import styled from 'styled-components';

import { devices } from 'shared/styles/components';

export const PlanFeaturesItemContainer = styled.div`
  display: grid;
  min-height: 68px;
  padding-bottom: 0px;
  grid-auto-columns: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  grid-template-rows: auto;
  border-bottom: 2px solid ${({ theme }) => theme.colors.borderSecondary};

  &.offerings-1 {
    grid-template-columns: 2fr minmax(180px, 180px);

    & > div:not(.feature) {
      justify-self: center;
    }
  }

  &.offerings-2 {
    grid-template-columns: 2fr minmax(180px, 180px) minmax(180px, 180px);
  }

  &.offerings-3 {
    grid-template-columns: 2fr minmax(180px, 180px) minmax(180px, 180px) minmax(180px, 180px);
  }

  @media screen and (max-width: 767px) {
    &.offerings-1 {
      grid-template-columns: 2fr 1fr;

      & > div:not(.feature) {
        justify-self: center;
      }
    }

    &.offerings-2 {
      grid-template-columns: 2fr 1fr 1fr;
    }

    &.offerings-3 {
      grid-template-columns: 2fr 1fr 1fr 1fr;
    }
  }

  & > div {
    grid-column-start: span 1;
    grid-column-end: span 1;
    grid-row-start: span 1;
    grid-row-end: span 1;
  }

  .feature {
    display: flex;
    align-items: center;
    margin-top: 0px;
    margin-bottom: 0px;
    padding: 8px 0;
    font-size: 18px;
    line-height: 24px;

    img {
      margin-top: 4px;
      margin-right: 8px;
      height: 24px;
      width: 24px;
      border-radius: 38%;
    }

    @media ${devices.laptopLMax} {
      font-size: 16px;
    }
  }
`;
